<div>
	@if (showBlock('day')) {
		<div class="picker">
			<ui-double-button
				[disabled]="disabled"
				[type]="isActive('day')"
				(action)="setDateType('day')"
				(actionRight)="toggleDropDown('day')"
				icon="fa fa-chevron-down"
			>
				{{ getLabel('day') | translate }}
			</ui-double-button>
			@if (showDropDown('day')) {
				<div class="dropdown-panel">
					<ic-date-picker
						class="day-picker"
						[options]="datePickerOptions"
						[selDate]="selDate"
						[locale]="locale"
						(dateChanged)="selectDate($event, 'day')"
					></ic-date-picker>
				</div>
			}
		</div>
	}
	@if (showBlock('week')) {
		<div class="picker">
			<ui-double-button
				[disabled]="disabled"
				[type]="isActive('week')"
				(action)="setDateType('week')"
				(actionRight)="toggleDropDown('week')"
				icon="fa fa-chevron-down"
			>
				{{ getLabel('week') | translate: weekNumber }}
			</ui-double-button>
			@if (showDropDown('week')) {
				<div class="dropdown-panel">
					<ic-date-picker
						class="week-datepicker"
						[options]="datePickerOptions"
						[selDate]="selDate"
						[locale]="locale"
						(dateChanged)="selectDate($event, 'week')"
					></ic-date-picker>
				</div>
			}
		</div>
	}
	@if (showBlock('month')) {
		<div class="picker">
			<ui-double-button
				[disabled]="disabled"
				[type]="isActive('month')"
				(action)="setDateType('month')"
				(actionRight)="toggleDropDown('month')"
				icon="fa fa-chevron-down"
			>
				{{ getLabel('month') | translate }}
			</ui-double-button>
			@if (showDropDown('month')) {
				<div class="dropdown-panel">
					<ic-date-picker
						[options]="datePickerOptions"
						[locale]="locale"
						[selDate]="selDate"
						(dateChanged)="selectDate($event, 'month')"
					></ic-date-picker>
				</div>
			}
		</div>
	}
	@if (showBlock('year')) {
		<div class="picker">
			<ui-double-button
				[disabled]="disabled"
				[type]="isActive('year')"
				(action)="setDateType('year')"
				(actionRight)="toggleDropDown('year')"
				icon="fa fa-chevron-down"
			>
				{{ getLabel('year') | translate }}
			</ui-double-button>
			@if (showDropDown('year')) {
				<div class="dropdown-panel">
					<ic-date-picker
						[options]="datePickerOptions"
						[locale]="locale"
						[selDate]="selDate"
						(dateChanged)="selectDate($event, 'year')"
					></ic-date-picker>
				</div>
			}
		</div>
	}
	@if (showBlock('range')) {
		<div class="picker picker-large">
			<ui-double-button
				[disabled]="disabled"
				[type]="isActive('range')"
				(action)="toggleDropDown('range')"
				(actionRight)="clearRange()"
				icon="fa fa-repeat"
				data-test="select-period-button"
			>
				{{ getLabel('range') | translate }}
			</ui-double-button>
			@if (showDropDown('range')) {
				<div class="dropdown-panel">
					<ul [hidden]="!customRange">
						<li role="button" (click)="selectRange(7)">
							<p>{{ 'time.last7Days' | translate }}</p>
						</li>
						<li role="button" (click)="selectRange(30)">
							<p>{{ 'time.last30Days' | translate }}</p>
						</li>
						<li role="button" (click)="selectRange(90)">
							<p>{{ 'time.last90Days' | translate }}</p>
						</li>
						<li role="button" (click)="selectRange(0)">
							<p>{{ 'time.other' | translate }}</p>
						</li>
					</ul>
					<ic-date-range-picker
						[hidden]="customRange"
						[options]="datePickerOptions"
						(dateRangeChanged)="selectRange(0, $event)"
					></ic-date-range-picker>
				</div>
			}
		</div>
	}
</div>
